import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, SelectItem } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { ILocation } from '../domain/ILocation';
import { IType } from '../domain/IType';
import { Product } from '../domain/product';
import { ProductStock } from '../domain/ProductStock';
import { IProduct } from 'app/Sales/point-of-sale/domain/IProduct';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';
import { AppUtils } from 'common/services/app.util';
import { Configuration } from 'config/config';
import { buildProductCreatePayload, buildProductUpdatePayload } from 'common/services/product-payload.util';
@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {
  @ViewChild("productName", { static: false }) productNameInput: ElementRef;
  @ViewChild("barcode", { static: false }) barcodeInput: ElementRef;
  tabIndex: number;
  loading: boolean = false;
  addProfileImage: any;
  dialogVisibility: boolean;
  uploadProfile: any;
  webcamImage: any = null;
  productId: string;
  mode: string;
  Product: Product;
  filePath: any;
  productTypes: SelectItem[];
  locations: SelectItem[];
  cities: ILocation[];
  types: IType[];
  selectedProductCategory:  any | null = null;
  selectedProductRole: string | null = null;
  productRoles: SelectItem[] = [];
  selectedProductType: any;
  selectedProductUnit: any;
  user: IUser;
  categories: any[];
  sourceCategories: any[];
  sourceTypes: any[];
  sourceUnits: any[];
  showAddStockBox: boolean = false;
  showRemoveStockBox: boolean = false;
  stock: ProductStock;
  productStockTotalQuantity: number;
  stocks: any[];
  enterSteps: any[];
  enterProductSteps: any[];
  enterStepsTAbTwo: any[];
  currentStep: any;
  currentStepTAbTwo: any;
  isConfirmationBox: boolean;
  confirmationDialogVisible = false;
  confirmationDialogMessage = '';
  private pendingConfirmationAction: (() => void) | null = null;
  productsInPanel: any[];
  sourceProducts: any[];
  first: number = 0;
  rowIndex: number = -1;
  orderProduct: IProduct[];
  paymentModes = [];
  index: number = 0;
  product: Product;
  currentProductStep: any;
  displayInventory: any;
  selectedPaymentMode: any;
  totalPayment: any;
  branch: IBranch;
  paymentModeTaxPos: boolean;

  categoryParam: string = '';

  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private router: Router,
    public config: Configuration,
  ) {
    this.route.queryParams.subscribe((queryParams) => {
      this.categoryParam = queryParams["category"] || '';
      this.updateBreadcrumbs();
    });
    route.params.subscribe((params) => {
      this.productId = params["id"];
      if (this.productId !== null && this.productId !== undefined) {
        this.user = AuthService.getLoggedInUser();
        this.getProductCategories();
        this.GetProductById(this.productId);
        this.mode = 'edit';
      } else {
        this.mode = 'add';
        this.filePath = "assets/layout/images/gymSupplimentAvatar.png";

      }
      this.updateBreadcrumbs();
    });
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AddProductComponent", label);
  }

  getCategoryName(): string {
    if (this.categoryParam) {
      return this.categoryParam;
    }
    const prod: any = this.Product;
    if (prod && prod.category) {
      if (typeof prod.category === 'object' && prod.category !== null) {
        return prod.category.name || prod.category.code || '';
      }
      return String(prod.category);
    }
    const selCat: any = this.selectedProductCategory;
    if (selCat) {
      if (typeof selCat === 'object' && selCat !== null) {
        return selCat.name || selCat.code || '';
      }
      return String(selCat);
    }
    return '';
  }

  updateBreadcrumbs() {
    const category = this.getCategoryName();
    if (category) {
      this.breadcrumbService.setItems([
        { label: "Products Categories", routerLink: ["/product-categories"] },
        { label: `${category} Products`, routerLink: ["/products-listing"], queryParams: { category: category } },
        { label: "Product" },
      ]);
    } else {
      this.breadcrumbService.setItems([
        { label: "Products Categories", routerLink: ["/product-categories"] },
        { label: "Product" },
      ]);
    }
  }

  goBack() {
    const category = this.getCategoryName();
    if (category) {
      this.router.navigate(['/products-listing'], { queryParams: { category: category } });
    } else {
      this.router.navigate(['/product-categories']);
    }
  }
  ngOnInit() {
    this.Product = new Product();
    this.product = new Product();
    this.stock = new ProductStock();
    this.categories = [];
    this.paymentModes = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
  ];
    this.addProfileImage = "Upload";
    this.dialogVisibility = false;
    this.user = AuthService.getLoggedInUser();
    // Refresh productImagePath from localStorage
    this.config.productImagePath = localStorage?.getItem('productImagePath');
    this.getProductCategories();
    this.getRoles();
    this.getProducts();
    this.getBranchById();
    this.stocks = [];
    this.selectedPaymentMode = "Cash-Reception";
    this.sourceTypes = [
      { label: 'Ready to Sell', value: 'Ready to Sell' },
      { label: 'Ingredients Based', value: 'Ingredients Based' },
      { label: 'Ingredients', value: 'Ingredients' }
    ];
    this.sourceUnits = [
      { label: 'Count', value: 'Count' },
      { label: 'Ltr', value: 'Ltr' },
      { label: 'ml', value: 'ml' },
      { label: 'kg', value: 'kg' },
      { label: 'g', value: 'g' },
      { label: 'scoop', value: 'scoop' },
    ];
    this.productStockTotalQuantity = undefined;
    this.selectedProductCategory= null;
    this.currentStep = 0;
    this.currentProductStep = 0;
    this.Product.imagePath = "assets/layout/images/gymSupplimentAvatar.png";
    this.currentStepTAbTwo = 0;
    this.isConfirmationBox = false;
    this.tabIndex = 0;
    this.orderProduct = [];
    this.enterProductSteps = [
      "rowQuantity-" + this.index,
      "rowBaseQuantity-" + this.index,
      "rowBasePrice-" + this.index,
      "rowUnit-" + this.index,
    ];

    if (this.mode == 'edit') {
      this.enterSteps = [
        "productName",
        "catagoryDd",
        "description",
        "totalQuantity",
        "wholeSalePrice",
        "purchasePrice",
        "normalPrice",
        "updateButton",
      ];
    } else if (this.mode == 'add') {
      this.enterSteps = [
        "productName",
        "catagoryDd",
        "description",
        "totalQuantity",
        "wholeSalePrice",
        "purchasePrice",
        "normalPrice",
        "saveButton"
      ];
    }

    if (this.mode == 'edit') {
      this.enterStepsTAbTwo = [
        "barcode",
        "reorderPoint",
        "reorderQuantity",
        "remarks",
        "updateButton",
      ];
    } else if (this.mode == 'add') {
      this.enterStepsTAbTwo = [
        "barcode",
        "reorderPoint",
        "reorderQuantity",
        "remarks",
        "saveButton"
      ];
    }

  }

  ngAfterViewInit() {
    this.productNameInput.nativeElement.focus();

  }

  getProductCategories() {
    this.loading = true;
    this.appServiceManager.get(`branches/${this.user.branch}/products/product-categories`).subscribe((res: any) => {
      if (res.length > 0) {
        this.categories = res;
        this.categoriesDropDown(this.categories);
        // this.checkIfProductCategoryExistInDropdown(this.categories)

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getRoles() {
    const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
    const companyId = AuthService.getLoggedInCompany() || this.user?.company;
    if (!branchId) {
      return;
    }
    this.appServiceManager.post(`branches/${branchId}/roles/actions/search`, {
      company: companyId,
      branch: branchId,
    }).subscribe((res: any) => {
      const roles = Array.isArray(res) ? res : [];
      const hiddenRoles = ['admin', 'super admin'];
      this.productRoles = roles
        .filter((role) => role?.name && !hiddenRoles.includes(String(role.name).trim().toLowerCase()))
        .map((role) => ({ label: role.name, value: role.name }));
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  categoriesDropDown(categories) {
    // this.sourceCategories = [{ name: 'Select Product Category', code: null }];
    this.sourceCategories = [{ name: '', code: null }];
    categories.forEach((element) => {
      this.sourceCategories.push({ name: element.name, code: element._id });
    });
  }

  GetProductById(productId) {
    const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
    if (!branchId || !productId) {
      return;
    }
    this.loading = true;
    this.appServiceManager.get(`branches/${branchId}/products/${productId}`).subscribe(
      data => {
        this.Product = data;
        this.stocks = this.Product.stocks;
        this.selectedProductCategory = this.Product.category;
        this.selectedProductRole = this.Product.role || null;
        this.selectedProductType = this.Product.type;
        this.selectedProductUnit = this.Product.unit;
        this.productStockTotalQuantity = this.Product.totalQuantity;
        if (this.selectedProductUnit == "ml")
          this.displayInventory = "Product in Liters: " + this.Product.totalQuantity / 1000 + 'Ltr';
        else if (this.selectedProductUnit == "g")
          this.displayInventory = "Product in Kilograms: " + this.Product.totalQuantity / 1000 + 'kg';
        this.filePath = this.Product.imagePath;
        this.uploadProfile = null; // Clear uploadProfile so it displays the stored image path
        this.orderProduct = this.Product.ingredients;
        // this.selectedProductCategory = this.Product.category ;
        this.checkIfProductCategoryExistInDropdown(this.Product);
        this.updateBreadcrumbs();
        this.loading = false;
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  getBranchById() {
    this.loading = true;
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      if (Array.isArray(this.branch.payments)) {
      this.branch.payments.forEach(payment => {
        const existingBank = this.paymentModes.find(option => option.value === `${payment.type}-${payment.name}`);
        if (!existingBank) {
            this.paymentModes.push({
                label: `${payment.type} - ${payment.name}`,
                value: `${payment.type}-${payment.name}`
            });
         }
       });
     }
      this.paymentModeTaxPos = this.branch.permissions?.paymentModeTaxPos || false
    }
    if(!this.branch){
    this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
        if (res) {
            res.payments.forEach(payment => {
                const existingBank = this.paymentModes.find(option => option.value === `${payment.type}-${payment.name}`);
                if (!existingBank) {
                    this.paymentModes.push({
                        label: `${payment.type} - ${payment.name}`,
                        value: `${payment.type}-${payment.name}`
                    });
                }
            });
        } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        }
        this.loading = false;
    },
        (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
        this.paymentModeTaxPos = this.branch.permissions?.paymentModeTaxPos || false
      }
}

  checkIfProductCategoryExistInDropdown(product) {
    let data = this.sourceCategories.find(x => x.code == product.category);
    if (data) {
      this.selectedProductCategory = { name: data.name, code: data.code };
    }
  }


  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
      setTimeout(() => {
        this.productNameInput.nativeElement.focus();
      }, 300);
    }
    if (index == 1) {
      this.tabIndex = 1;
      setTimeout(() => {
        this.barcodeInput.nativeElement.focus();
      }, 300);
    }
  }

  captureImageDialogShow(type) {
    this.addProfileImage = type;
    this.dialogVisibility = true;
  }

  removeProfileImage() {
    this.uploadProfile = "";
    this.Product.imagePath = "";
    this.Product.imagePath = "assets/layout/images/gymSupplimentAvatar.png";
  }

  getProductImageUrl(imagePath: string): string {
    if (!imagePath) {
      return 'assets/layout/images/gymSupplimentAvatar.png';
    }
    // If it's base64 (during upload), return as is
    if (this.uploadProfile && imagePath.startsWith('data:image')) {
      return imagePath;
    }
    // If it's already a full URL, return as is
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    // If it's a default placeholder, return as is
    if (imagePath.includes('gymSupplimentAvatar.png') || (imagePath.includes('assets/layout/images') && !imagePath.includes('company_'))) {
      return imagePath;
    }
    // Refresh config path from localStorage
    this.config.productImagePath = localStorage?.getItem('productImagePath');
    // If productImagePath is not set, try to construct it from user data
    if (!this.config.productImagePath && this.user) {
      this.config.productImagePath = `assets/layout/images/company_${this.user.company}/branch_${this.user.branch}/products/`;
    }
    if (this.config.productImagePath && this.config.Server) {
      // Ensure no double slashes
      const basePath = this.config.Server.endsWith('/') ? this.config.Server.slice(0, -1) : this.config.Server;
      return basePath + '/' + this.config.productImagePath + imagePath;
    }
    return 'assets/layout/images/gymSupplimentAvatar.png';
  }

  hideAddProfileImage() {
    this.dialogVisibility = false;
  }

  handleImagefromNewProfile(webcamImage) {
    if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.Product.imagePath = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
    }
  }

  uploadProductImage(file: any, productId, isAddMode = false): Promise<any> {
    return new Promise((resolve, reject) => {
      let formData: FormData = new FormData();
      if (file) {
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        if (!branchId) {
          reject(new Error('Branch is required to upload product image'));
          return;
        }
        formData.append("productImage", file, file.name);
        formData.append("productId", productId);
        formData.append("isAddMode", isAddMode.toString());

        this.appServiceManager.post(`branches/${branchId}/products/actions/upload`, formData)
          .subscribe(
            (res: any) => {
              // Image uploaded successfully - refresh product to get updated imagePath
              if (productId) {
                const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
                if (!branchId) {
                  resolve(res);
                  return;
                }
                this.appServiceManager.get(`branches/${branchId}/products/${productId}`).subscribe(
                  (productRes: any) => {
                    if (productRes) {
                      this.Product = productRes;
                      this.filePath = this.Product.imagePath;
                      this.uploadProfile = null; // Clear uploadProfile so it displays the stored image
                    }
                    resolve(res);
                  },
                  (error: any) => {
                    console.error("Error fetching updated product:", error);
                    resolve(res); // Still resolve even if refresh fails
                  }
                );
              } else {
                resolve(res);
              }
            },
            (error: any) => {
              this.messageService.clear();
              this.messageService.add({ severity: "error", summary: "Error Message", detail: error });
              reject(error);
            }
          );
      } else {
        resolve(null);
      }
    });
  }
  convertIntoBase(ingredient, ingredientUnit) {
    if (ingredientUnit == 'Ltr' || ingredientUnit == 'kg') {
      ingredient = Math.round(ingredient * 1000);
    }
    return ingredient;
  }
  calculateTotalPayment(stock, price, unit) {
    let totalPayment = 0;
       if (unit === 'Ltr') {
        totalPayment = stock * price;
    } else if (unit === 'ml') {
        totalPayment = (stock / 1000) * price;
    } else if (unit === 'kg') {
        totalPayment = stock * price;
    } else if (unit === 'g') {
        totalPayment = (stock / 1000) * price;
    } else if(unit === 'Count') {
         totalPayment = stock * price;
    }

    return totalPayment;
  }

  save() {
    this.product.totalQuantity = this.Product.totalQuantity;
    this.product.wholeSalePrice = this.Product.wholeSalePrice;
    this.product.cost = this.Product.cost;
    this.product.normalPrice = this.Product.normalPrice;
      if (this.selectedProductType == undefined || this.selectedProductType == null || this.selectedProductType == '') {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Please Select Product Type' });
      return;
  }
    if (this.Product.name == undefined || this.Product.name == null || this.Product.name == '') {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Please Add Product Name' });
      return;
  }

    if (this.selectedProductCategory == '' || this.selectedProductCategory == null || this.selectedProductCategory == '') {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Please Select Product Category' });
      return;
  }
      if (this.product.totalQuantity == undefined || this.product.totalQuantity == 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Please Add Product Total Stock Quantity' });
      return;

  }   if (this.product.normalPrice == undefined || this.product.normalPrice == 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Please Add Product Sale Price' });
      return;
  }

    if (this.Product.gstOnProduct > 100) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The GST value must be calculated as a percentage of the sale value..' });
      return;
  }
  this.openConfirmationDialog("Are you sure you want to save Product?", () => {
      var date = new Date();
        this.Product.createdOn = date;
        this.Product.company = this.user.company;
        this.Product.branch = this.user.branch;
        if (this.selectedProductType == "Ready to Sell") {
          this.Product.unit = "Count";
        }
        else {
          this.Product.unit = this.selectedProductUnit;
        }
        if (this.Product.unit == 'Ltr' || this.Product.unit == 'ml') {
          this.Product.totalQuantity = this.convertIntoBase(this.Product.totalQuantity, this.Product.unit);
          this.Product.unit = "ml";
        }
        else if (this.Product.unit == 'kg' || this.Product.unit == 'g') {
          this.Product.totalQuantity = this.convertIntoBase(this.Product.totalQuantity, this.Product.unit);
          this.Product.unit = "g";
        }
        if (this.selectedProductCategory != undefined) {
          this.Product.category = this.selectedProductCategory;
        }
        this.Product.role = this.selectedProductRole || '';
        this.stock.stockQuantityAdded = this.Product.totalQuantity;
        this.stock.salePrice = this.Product.normalPrice;
        this.stock.purchasePrice = this.Product.cost;
        this.stock.wholesalePrice = this.Product.wholeSalePrice;
        this.Product.stocks = []
        this.Product.type = this.selectedProductType;
        this.Product.stocks.push(this.stock);
        this.Product.ingredients = this.orderProduct;
        this.stock.paymentMode = '';
        this.stock.totalPayment = 0;
        // Store the base64 image temporarily and remove it from Product before saving
        const tempImagePath = this.Product.imagePath;
        const tempUploadProfile = this.uploadProfile;
        // Remove base64 from Product.imagePath before saving
        if (this.uploadProfile && this.uploadProfile.startsWith('data:image')) {
          this.Product.imagePath = '';
        }
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        this.appServiceManager.post(
          `branches/${branchId}/products`,
          buildProductCreatePayload(this.Product, {
            company: this.user.company,
            branch: branchId,
          }, {
            stocks: this.Product.stocks,
            ingredients: this.orderProduct,
            createdOn: this.Product.createdOn,
          }),
        ).subscribe(async (res: any) => {
          if (res.status == true) {
            this.Product = res.product;
            // Upload image separately if it exists and wait for it to complete
            if (tempUploadProfile && tempUploadProfile.startsWith('data:image')) {
              const file = AppUtils.base64ToFile(tempUploadProfile, `${this.Product.name}.png:${this.user.company}:${this.user.branch}`);
              await this.uploadProductImage(file, this.Product._id);
            }
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Successfully Registered' });
           const cat = this.getCategoryName();

if (this.route.snapshot.queryParamMap.get('from') === 'products-listing') {
    this.router.navigate(['/products-listing'], {
        queryParams: {}
    });
} else if (cat) {
    this.router.navigate(['/product', this.Product._id], {
        queryParams: { category: cat }
    });
} else {
    this.router.navigateByUrl('product/' + this.Product._id);
}
          } else {
            // Restore imagePath if save failed
            this.Product.imagePath = tempImagePath;
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: res.error });
          }
        },
          (error) => {
            // Restore imagePath if save failed
            this.Product.imagePath = tempImagePath;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });

    });
  }

  private openConfirmationDialog(message: string, action: () => void) {
    this.confirmationDialogMessage = message;
    this.pendingConfirmationAction = action;
    this.isConfirmationBox = true;
    this.confirmationDialogVisible = true;
  }

  cancelConfirmationDialog() {
    this.confirmationDialogVisible = false;
    this.pendingConfirmationAction = null;
    this.isConfirmationBox = false;
  }

  confirmConfirmationDialog() {
    const action = this.pendingConfirmationAction;
    this.cancelConfirmationDialog();
    action?.();
  }

  update() {

    if (this.Product.gstOnProduct > 100) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'GST Value Must Be In Percentage' });
      return;
    }
    this.openConfirmationDialog("Are you sure you want to Update Product?", () => this.confirmProductUpdate());
  }

  confirmProductUpdate() {
        var date = new Date();
        this.Product.createdOn = date;
        this.Product.company = this.user.company;
        this.Product.branch = this.user.branch;
        this.Product.type = this.selectedProductType;
        this.Product.unit = this.selectedProductUnit;
        this.Product.ingredients = this.orderProduct;
        this.Product.category = this.selectedProductCategory;
        this.Product.role = this.selectedProductRole || '';
        // Store the base64 image temporarily and remove it from Product before saving
        const tempImagePath = this.Product.imagePath;
        const tempUploadProfile = this.uploadProfile;
        const oldProductImage = this.filePath && !this.filePath.startsWith('data:image') ? this.filePath : null;
        // Remove base64 from Product.imagePath before saving
        if (this.uploadProfile && this.uploadProfile.startsWith('data:image')) {
          this.Product.imagePath = '';
        }
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        this.appServiceManager.patch(
          `branches/${branchId}/products/${this.Product._id}`,
          buildProductUpdatePayload(this.Product, {
            company: this.user.company,
            branch: branchId,
          }, {
            ingredients: this.orderProduct,
            stocks: this.Product.stocks,
          }),
        ).subscribe(async (res: any) => {
          if (res?.status === false) {
            this.Product.imagePath = tempImagePath;
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: res.error || 'Something Went Wrong',
            });
            return;
          }
          if (res?.product) {
            this.Product = res.product;
            // Upload image separately if it exists and wait for it to complete
            if (tempUploadProfile && tempUploadProfile.startsWith('data:image')) {
              const file = AppUtils.base64ToFile(tempUploadProfile, `${this.Product.name}.png:${this.user.company}:${this.user.branch}`);
              await this.uploadProductImage(file, this.Product._id, true);
            } else if (oldProductImage && !this.Product.imagePath) {
              // Handle image deletion if needed
              this.appServiceManager.delete(`products/profileimages/${this.Product._id}`).subscribe((res: any) => {
                if (res.message == "Profile image deleted successfully") {
                  this.messageService.clear();
                  this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Image Deleted' });
                }
              });
            }
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Successfully Updated' });
          } else {
            // Restore imagePath if update failed
            this.Product.imagePath = tempImagePath;
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            // Restore imagePath if update failed
            this.Product.imagePath = tempImagePath;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
  }

  onPaymentModeChange(value: string) {
    this.selectedPaymentMode = value;
}


  openAddStockBox() {
    this.showAddStockBox = true;
    this.stock = new ProductStock();
    this.stock.salePrice = this.Product.normalPrice;
    this.stock.purchasePrice = this.Product.cost;
    this.totalPayment = this.stock.purchasePrice;
    this.stock.wholesalePrice = this.Product.wholeSalePrice;
    this.productStockTotalQuantity = this.Product.totalQuantity;
  }
  openRemoveStockBox() {
    this.showRemoveStockBox = true;
    this.stock = new ProductStock();
    this.stock.salePrice = this.Product.normalPrice;
    this.stock.purchasePrice = this.Product.cost;
    this.stock.wholesalePrice = this.Product.wholeSalePrice;
    this.productStockTotalQuantity = this.Product.totalQuantity;
  }

  closeAddStockBox() {
    this.showAddStockBox = false;
  }
  closeRemoveStockBox() {
    this.showRemoveStockBox = false;
  }

  countTotalStockQuantity(enterdStock) {
    this.totalPayment = this.calculateTotalPayment(enterdStock,this.stock.purchasePrice,this.Product.unit);
    if (this.Product.unit == "Ltr" || this.Product.unit == "ml" || this.Product.unit == 'kg' || this.Product.unit == 'g') {
      enterdStock = this.convertIntoBase(enterdStock, this.Product.unit);
    }
    this.productStockTotalQuantity = this.Product.totalQuantity + enterdStock;
  }

  removeTotalStockQuantity(enterdStock) {
    if (this.Product.unit == "Ltr" || this.Product.unit == "ml" || this.Product.unit == 'kg' || this.Product.unit == 'g') {
      enterdStock = this.convertIntoBase(enterdStock, this.Product.unit);
    }
    this.productStockTotalQuantity = this.Product.totalQuantity - enterdStock;
    this.totalPayment = this.totalPayment - this.totalPayment*enterdStock;
  }

  saveStock() {
    this.openConfirmationDialog("Are you sure you want to add stock?", () => {
        this.stock.stockQuantityAdded = this.convertIntoBase(this.stock.stockQuantityAdded, this.Product.unit);
        if (this.Product.unit == "Ltr") {
          this.Product.unit = 'ml';
        }
        else if (this.Product.unit == "kg") {
          this.Product.unit = 'g';
        }
        this.stock.paymentMode = this.selectedPaymentMode;
        this.stock.totalPayment = this.totalPayment;
        this.Product.stocks.push(this.stock);
        this.Product.totalQuantity = this.productStockTotalQuantity;
        this.Product.cost = this.stock.purchasePrice;
        this.Product.wholeSalePrice = this.stock.wholesalePrice;
        this.Product.normalPrice = this.stock.salePrice;
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        this.appServiceManager.patch(
          `branches/${branchId}/products/${this.Product._id}`,
          buildProductUpdatePayload(this.Product, {
            company: this.user.company,
            branch: branchId,
          }, {
            stocks: this.Product.stocks,
            totalPayment: this.stock.totalPayment ?? this.totalPayment,
            paymentMode: this.stock.paymentMode ?? this.selectedPaymentMode,
          }),
        ).subscribe((res: any) => {
          if (res?.status === false) {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: res.error || 'Something Went Wrong',
            });
            this.showAddStockBox = false;
            return;
          }
          if (res?.status === true || res?.product) {
            this.GetProductById(this.productId);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Stock Added' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.showAddStockBox = false;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
    });
  }
  removeStock() {
    this.openConfirmationDialog("Are you sure you want to remove stock?", () => {
        this.stock.stockQuantityRemoved = this.convertIntoBase(this.stock.stockQuantityRemoved, this.Product.unit);
        if (this.Product.unit == "Ltr") {
          this.Product.unit = 'ml';
        }
        else if (this.Product.unit == "kg") {
          this.Product.unit = 'g';
        }
        this.Product.stocks.push(this.stock);
        this.Product.totalQuantity = this.productStockTotalQuantity;
        this.Product.cost = this.stock.purchasePrice;
        this.Product.wholeSalePrice = this.stock.wholesalePrice;
        this.Product.normalPrice = this.stock.salePrice;
        const branchId = AuthService.getLoggedInBranch() || this.user.branch;
        this.appServiceManager.patch(
          `branches/${branchId}/products/${this.Product._id}`,
          buildProductUpdatePayload(this.Product, {
            company: this.user.company,
            branch: branchId,
          }, {
            stocks: this.Product.stocks,
          }),
        ).subscribe((res: any) => {
          if (res?.status === false) {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: res.error || 'Something Went Wrong',
            });
            this.showRemoveStockBox = false;
            return;
          }
          if (res?.status === true || res?.product) {
            this.GetProductById(this.productId);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Stock Removed' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.showRemoveStockBox = false;
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
    });
  }

  hotkeys($event) {
    if ($event.keyCode == 39 || $event.keyCode == 37) {
      var confirmationBox = document.querySelector("app-confirm-dialog [role='dialog']");
      if (!confirmationBox) {
        return;
      }
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }
    else if ($event.keyCode == 13 && !this.isConfirmationBox && this.tabIndex === 0) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele.disabled && nextId == "saveButton") {
        document.getElementById("productName").focus();
        this.currentStep = 0;

      } else if (ele.disabled && nextId == "updateButton") {
        document.getElementById("productName").focus();
        this.currentStep = 0;

      } else if (nextId == "catagoryDd") {
        let ele = document.getElementById("catagoryDd").children[0] as HTMLElement;
        ele.click();
        this.currentStep = 1;
      } else {
        ele.focus();
        this.currentStep = nextStep;
      }
    } else if ($event.keyCode == 13 && !this.isConfirmationBox && this.tabIndex === 1) {
      var nextStep = this.enterStepsTAbTwo.length - 1 > this.currentStepTAbTwo ? this.currentStepTAbTwo + 1 : 0;
      var nextId = this.enterStepsTAbTwo[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele.disabled && nextId == "saveButton") {
        document.getElementById("barcode").focus();
        this.currentStepTAbTwo = 0;

      } else if (ele.disabled && nextId == "updateButton") {
        document.getElementById("barcode").focus();
        this.currentStepTAbTwo = 0;

      } else {
        ele.focus();
        this.currentStepTAbTwo = nextStep;
      }
    }
    else if ($event.keyCode == 113) {
      this.router.navigateByUrl("/product");

    }

  }

  hotClick($event) {
    if (this.tabIndex === 0) {
      let currentClickLocation = $event.target.id;
      let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.currentStep = indexOfClickField;
      } else {
        this.currentStep = this.currentStep;
      }
    } else if (this.tabIndex === 1) {
      let currentClickLocation = $event.target.id;
      let indexOfClickField = this.enterStepsTAbTwo.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.currentStepTAbTwo = indexOfClickField;
      } else {
        this.currentStepTAbTwo = this.currentStepTAbTwo;
      }
    }

  }

  getProducts() {
    this.loading = true;
    this.appServiceManager.get(`branches/${this.user.branch}/products`).subscribe((res: any) => {
      if (res.length > 0) {
        this.productsInPanel = res;
        this.productsInPanel = this.productsInPanel.filter(product => product.type == "Ingredients");
        this.sourceProducts = this.productsInPanel;

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }


  searchPanelProducts(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (!value) {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.sourceProducts).filter(
              cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.productsInPanel = source.filter(distinct);

          if (this.productsInPanel.length === 0) {
            this.productsInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.productsInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.productsInPanel = [...this.productsInPanel];
          }
        }
      } else {
        this.productsInPanel = Object.assign([], this.sourceProducts);
        this.productsInPanel = [...this.productsInPanel];
      }
    }

  }

  onPageChange(event) {
    this.first = event.first;
  }



  onProductRowSelect(event, productsPanel: OverlayPanel) {
    let check = this.orderProduct.filter(x => x.code === event.data.code);
    if (check.length > 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Product Already Added' });
    } else {
      let products = [...this.orderProduct];
      let productToBeSale = new IProduct();
      productToBeSale.name = event.data.name;
      productToBeSale.code = event.data.code;
      productToBeSale.unit = event.data.unit;
      productToBeSale.quantity = 1;
      productToBeSale.totalQuantity = event.data.totalQuantity;
      productToBeSale.cost = event.data.cost;
      productToBeSale.wholeSalePrice = event.data.wholeSalePrice;
      productToBeSale.normalPrice = event.data.normalPrice;
      productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.cost;
      products.push(productToBeSale);
      this.orderProduct = products;
      productsPanel.hide();
      this.index = this.orderProduct.length - 1;
      this.enterProductSteps = [
        "rowQuantity-" + this.index,
        "rowBaseQuantity-" + this.index,
        "rowBasePrice-" + this.index,
        "rowUnit-" + this.index,
      ];
      setTimeout(() => {
        document.getElementById(this.enterProductSteps[0]).focus()
        this.currentProductStep = 0;

      }, 500);
    }
  }
  removeSelectedProduct(product) {
    let products = [...this.orderProduct];
    let index = this.orderProduct.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      this.orderProduct = products;
      this.index = this.orderProduct.length - 1;
      this.enterProductSteps = [
        "rowQuantity-" + this.index,
        "rowBaseQuantity-" + this.index,
        "rowBasePrice-" + this.index,
        "rowUnit-" + this.index,
      ];

      setTimeout(() => {
        if (this.orderProduct.length > 0) {
          document.getElementById(this.enterProductSteps[0]).focus()
          this.currentProductStep = 0;
        }
      }, 300);
    }
  }

  quantityChangeEvent(product, type) {
    let num = 0;
    if (type === "quantity") {
      num = product.cost * product.quantity;
      product.subTotal = Math.round(num);
      let index = this.orderProduct.indexOf(product);
      this.orderProduct[index] = product;

    }
  }

}
